import React from 'react';

import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
} from '@gogame/components';
import { usePercentFormat } from '@gogame/intl-ts';

const AgeAndGenders = ({ data }) => {
  const percentFormatter = usePercentFormat();

  return data?.length ? (
    <TableContainer>
      <Table width={'100%'}>
        <TableHead>
          <TableRow>
            <TableCell col={'type'}>Gender</TableCell>
            {data.map(({ ageGroupName }, i) => (
              <TableCell key={`header_${i}`}>{ageGroupName}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell col={'type'}>Male</TableCell>
            {data.map(({ male }, i) => (
              <TableCell key={`male_age_${i}`}>
                <Typography>{percentFormatter(male)}</Typography>
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell col={'type'}>Female</TableCell>
            {data.map(({ female }, i) => (
              <TableCell key={`female_age_${i}`}>
                <Typography>{percentFormatter(female)}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Typography color={'textSecondary'}>
      No Age and Gender Distribution of Subscribes
    </Typography>
  );
};

export default AgeAndGenders;
